import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("HOUSEHOLD_TICKETS");
const CRUD_ACTION_HANDLERS = getActionHandler("HOUSEHOLD_TICKETS");

export default function criticalpaths(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
